import React from "react";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const useStyles = makeStyles(() => ({
    square: {
        display: "block",
        position: "relative",
        paddingBottom: "100%", // Default square shape
    },
    squareContent: {
        position: "absolute",
        left: 0,
        top: 0,
        height: "100%",
        minHeight: "100px", // fix picker not showing images
        width: "100%",
    },
    normal: {
        paddingBottom: "unset !important", // Remove aspect ratio enforcement
        height: "auto !important",
    },
    normalContent: {
        position: "static !important",
        height: "auto !important",
        width: "auto !important",
    },
    // debug: {
    //     backgroundColor: "rgba(255, 0, 0, 0.3) !important", // Light red tint for debugging
    // },
}));

export const Square = ({ children, alwaysSq = false }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const shouldSquare = isLargeScreen || alwaysSq;

    return (
        <div className={`${classes.square} ${!shouldSquare ? classes.normal : ""}`}>
            <div className={`${classes.squareContent} ${!shouldSquare ? classes.normalContent : ""}`}>
                {children}
            </div>
        </div>
    );
};
